import { useEffect, useState } from "react";

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 100);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  let className = "fixed bottom-24 sm:bottom-20 right-4 sm:right-12 z-50 w-12 h-12 rounded-full bg-slate-950 text-white flex items-center justify-center shadow-lg transition-all duration-300 ease-in-out border-2 border-solid border-white " + (visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none');

  return (
    <button
      onClick={scrollToTop}
      className={className}
      aria-label="Наверх"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={3}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
        />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;
